
export default {
  name: 'VideoEmbed',

  props: {
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      opened: false,
    };
  },

  methods: {
    toggle() {
      this.opened = !this.opened;
    },
    close() {
      this.opened = false;
    },
  },
};
